/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface ParticipantMetadataProps {
  role: string | null;
}

export class ParticipantMetadataRecord extends Record<ParticipantMetadataProps>({
  role: null as any,
}) {
  public static fromJS(json: { role: string | null }): ParticipantMetadataRecord {
    if (json == null) {
      throw new Error('ParticipantMetadataRecord.fromJS: parameter cannot be null');
    }
    return new ParticipantMetadataRecord({
      role: json.role,
    });
  }

  public static fromJSUnsafe(json: { role: string | null }): [ParticipantMetadataRecord, Error[]] {
    if (json == null) {
      throw new Error('ParticipantMetadataRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new ParticipantMetadataRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      role: tryOrDefault(
        () => json.role,
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: ParticipantMetadataProps) {
    super(props);
    if (props == null) {
      throw new Error('ParticipantMetadataRecord constructor parameter cannot be null');
    }
  }
}

export abstract class ParticipantMetadataViewModelBase implements ParticipantMetadataProps {
  protected readonly _props: ParticipantMetadataProps;
  private _json?: ParticipantMetadataProps;

  get role(): string | null {
    return this._props.role;
  }

  constructor(props: ParticipantMetadataProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        role: this._props.role,
      };
    }
    return this._json;
  }
}
